<div *ngIf="editable" class="editable">
  <div class="editrow">
    <mat-form-field id="name">
      <input matInput [(ngModel)]="hubInformation.name" placeholder="name" />
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field id="address">
      <textarea matInput [(ngModel)]="hubInformation.address" placeholder="street address" rows="3"></textarea>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field id="city">
      <input matInput [(ngModel)]="hubInformation.city" placeholder="city" />
    </mat-form-field>
    <mat-form-field id="postcode">
      <input matInput [(ngModel)]="postCode" placeholder="postcode" />
    </mat-form-field>
    <mat-form-field id="country">
      <input matInput [(ngModel)]="hubInformation.country" placeholder="country" />
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field class="phone">
      <input matInput [(ngModel)]="phone" placeholder="phone number" />
    </mat-form-field>
    <mat-form-field class="phone with_left_margin">
      <input matInput [(ngModel)]="mobile" placeholder="mobile number" />
    </mat-form-field>
    <mat-form-field class="email">
      <input matInput [(ngModel)]="hubInformation.contact_email" placeholder="email address" />
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field id="notes">
      <textarea matInput [(ngModel)]="hubInformation.contact_note" placeholder="notes" rows="3"></textarea>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field id="mat_shipment_id">
      <mat-select class="form-control" id="shipment_id" required placeholder="shipment"
        [(ngModel)]="hubInformation.shipment_number" name="shipment_number">
        <mat-option *ngFor="let shipment of shipment_list" [value]="shipment.shipment_id">
          {{shipment.shipment_id}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field id="mat_carton_number" class="with_left_margin">
      <input matInput [(ngModel)]="hubInformation.carton_number" type="number" placeholder="carton number" />
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field id="mat_stock_status">
      <mat-select class="form-control" id="stock_status" required placeholder="stock status"
        [(ngModel)]="hubInformation.stock_status_id" name="stock_status_id">
        <mat-option *ngFor="let stock_status of stock_statuses" [value]="stock_status.stock_status_id">
          {{stock_status.stock_status_text}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field id="mat_stock_location" class="with_left_margin">
      <mat-select class="form-control" id="stock_location" required placeholder="stock location"
        [(ngModel)]="hubInformation.stock_location_id" name="stock_location_id">
        <mat-option *ngFor="let stock_location of stock_locations" [value]="stock_location.stock_location_id">
          {{stock_location.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field id="mat_installation_state">
      <mat-select class="form-control" id="stock_office_status" required placeholder="office status"
        [(ngModel)]="hubInformation.stock_office_status_id" name="stock_office_status_id">
        <mat-option *ngFor="let stock_office of stockOfficeStatus" [value]="stock_office.stock_office_status_id">
          {{stock_office.stock_office_status_details}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field id="mat_customer_type">
      <mat-select class="form-control" id="customer_type" required placeholder="customer type"
        [(ngModel)]="hubInformation.customer_type_id" name="customer_type_id">
        <mat-option *ngFor="let customer_type of customer_types" [value]="customer_type.customer_type_id">
          {{customer_type.description}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field id="mat_installation_state" class="with_left_margin">
      <mat-select class="form-control" id="installation_state" required placeholder="installation state"
        [(ngModel)]="hubInformation.installation_state_id" name="installation_state_id">
        <mat-option *ngFor="let installation_state of installation_states"
          [value]="installation_state.installation_state_id">{{installation_state.installation_state_text}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field id="mat_customer_type">
      <input matInput placeholder="dispatched on" [(ngModel)]="hubInformation.dispatched">
      <!-- input matInput [matDatepicker]="dispatched" placeholder="dispatched on" [(ngModel)]="hubInformation.dispatched">
      <mat-datepicker-toggle matSuffix [for]="dispatched"></mat-datepicker-toggle>
      <mat-datepicker #dispatched></mat-datepicker -->
    </mat-form-field>
    <mat-form-field id="mat_installation_state">
      <input matInput placeholder="installed on" [(ngModel)]="hubInformation.installed">
      <!-- input matInput [matDatepicker]="installed" placeholder="installed on" [(ngModel)]="hubInformation.installed">
      <mat-datepicker-toggle matSuffix [for]="installed"></mat-datepicker-toggle>
      <mat-datepicker #installed></mat-datepicker -->
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field id="mat_customer_type">
      <mat-select class="form-control" id="installer_list" required placeholder="installer"
        [(ngModel)]="hubInformation.installer_id" name="installer_id">
        <mat-option *ngFor="let installer of installer_list" [value]="installer.installer_id">
          {{installer.installer_name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field id="mat_installation_state" class="with_left_margin">
      <input matInput [(ngModel)]="hubInformation.stock_docket_number" placeholder="docket number" />
    </mat-form-field>
    <div class="panel">
      <button mat-raised-button (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="!isValid()">Save</button>
    </div>
  </div>
  <div class="editrow">
    <p class="error" *ngFor="let error of errorMessages">{{error}}</p>
  </div>
</div>
<div *ngIf="!editable" (click)="edit()" class="editable">
  <div class="displayrow"><label class="left">name: </label>{{hubInformation.name}}</div>
  <div class="displayrow"><label class="left top_align">address: </label><span
      class="address">{{hubInformation.address}}</span></div>
  <div class="displayrow">
    <label class="left" *ngIf="hubInformation.city">city: </label>{{hubInformation.city}}<ng-container
      *ngIf="hubInformation.city && postCode">, </ng-container>
    <label class="left" *ngIf="!hubInformation.city && postCode">postcode: </label><span
      (click)="openGoogleMaps($event,postCode)">{{postCode}}</span>
    <ng-container *ngIf="(hubInformation.city || hubInformation.postcode) && hubInformation.country">, </ng-container>
    {{hubInformation.country}}
  </div>
  <div class="displayrow">
    <span class="label_plus" *ngIf="phone"><label class="left">phone: </label> {{phone}} </span>
    <span class="label_plus" *ngIf="mobile"><label [class]="!phone ? 'left' : 'right'">mobile: </label> {{mobile}} </span>
  </div>
  <div class="displayrow"><label class="left">email: </label>{{hubInformation.contact_email}}</div>
  <div class="displayrow" *ngIf="hubInformation.contact_note"><label class="left top_align">notes: </label><span
      class="address">{{hubInformation.contact_note}}</span></div>
  <div class="displayrow">
    <span class="label_plus"><label class="left">shipment:</label>{{hubInformation.shipment_number}}</span>
    <span class="label_plus"><label class="right">carton:</label>{{hubInformation.carton_number}}</span>
  </div>
  <div class="displayrow">
    <span class="label_plus"><label class="left" for="stock_status">stock status:
      </label>{{hubInformation.stock_status_text}} </span>
    <span class="label_plus"><label class="right" for="stock_location">location:
      </label>{{hubInformation.stock_location_text}}</span>
    <span class="label_plus"><label class="right" for="stock_office_status">office status:
      </label>{{hubInformation.stock_office_status_details}}</span>
  </div>
  <div class="displayrow">
    <span class="label_plus"><label class="left">customer type:</label>{{hubInformation.customer_type_text}}</span>
    <span class="label_plus"><label class="right">install
        state:</label>{{hubInformation.installation_state_text}}</span>
    <span class="label_plus"><label class="right">installed:</label>{{hubInformation.installed}}</span>
  </div>
  <div class="displayrow">
    <span class="label_plus"><label class="left"
        for="dispatched">dispatched:</label>{{hubInformation.dispatched}}</span>
    <span class="label_plus"><label class="right">installed:</label>{{hubInformation.installed}}</span>
  </div>
  <div class="displayrow">
    <span class="label_plus"><label class="left">installer:</label>{{hubInformation.installer_name}}</span>
    <span class="label_plus"><label class="right">docket:</label>{{hubInformation.stock_docket_number}}</span>
  </div>
  <div class="displayrow"></div>
</div>
